var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { faEdit, faKey, faPlus, faTrash, faTrashRestore } from "@fortawesome/free-solid-svg-icons";
import { useEventBus } from "@vueuse/core";
import axios from "axios";
import { GalaxyApi } from "@/api";
import Filtering, { contains, equals, toBool } from "@/utils/filtering";
import _l from "@/utils/localization";
import { withPrefix } from "@/utils/redirect";
import { errorMessageAsString } from "@/utils/simple-error";
import {} from "./types";
const { emit } = useEventBus("grid-router-push");
/**
 * Request and return data from server
 */
function getData(offset, limit, search, sort_by, sort_desc) {
    return __awaiter(this, void 0, void 0, function* () {
        const query = {
            limit: String(limit),
            offset: String(offset),
            search: search,
            sort_by: sort_by,
            sort_desc: String(sort_desc),
        };
        const queryString = new URLSearchParams(query).toString();
        const { data } = yield axios.get(withPrefix(`/admin/groups_list?${queryString}`));
        return [data.rows, data.rows_total];
    });
}
/**
 * Actions are grid-wide operations
 */
const actions = [
    {
        title: "Create New Group",
        icon: faPlus,
        handler: () => {
            emit("/admin/form/create_group");
        },
    },
];
/**
 * Declare columns to be displayed
 */
const fields = [
    {
        key: "name",
        title: "Name",
        type: "operations",
        operations: [
            {
                title: "Edit Name",
                icon: faEdit,
                condition: (data) => !data.deleted,
                handler: (data) => {
                    emit(`/admin/form/rename_group?id=${data.id}`);
                },
            },
            {
                title: "Edit Permissions",
                icon: faKey,
                condition: (data) => !data.deleted,
                handler: (data) => {
                    emit(`/admin/form/manage_users_and_roles_for_group?id=${data.id}`);
                },
            },
            {
                title: "Delete",
                icon: faTrash,
                condition: (data) => !data.deleted,
                handler: (data) => __awaiter(void 0, void 0, void 0, function* () {
                    if (confirm(_l("Are you sure that you want to delete this group?"))) {
                        const { error } = yield GalaxyApi().DELETE("/api/groups/{group_id}", {
                            params: {
                                path: { group_id: String(data.id) },
                            },
                        });
                        if (error) {
                            return {
                                status: "danger",
                                message: `Failed to delete '${data.name}': ${errorMessageAsString(error)}`,
                            };
                        }
                        return {
                            status: "success",
                            message: `'${data.name}' has been deleted.`,
                        };
                    }
                }),
            },
            {
                title: "Purge",
                icon: faTrash,
                condition: (data) => !!data.deleted,
                handler: (data) => __awaiter(void 0, void 0, void 0, function* () {
                    if (confirm(_l("Are you sure that you want to purge this group?"))) {
                        const { error } = yield GalaxyApi().POST("/api/groups/{group_id}/purge", {
                            params: {
                                path: { group_id: String(data.id) },
                            },
                        });
                        if (error) {
                            return {
                                status: "danger",
                                message: `Failed to purge '${data.name}': ${errorMessageAsString(error)}`,
                            };
                        }
                        return {
                            status: "success",
                            message: `'${data.name}' has been purged.`,
                        };
                    }
                }),
            },
            {
                title: "Restore",
                icon: faTrashRestore,
                condition: (data) => !!data.deleted,
                handler: (data) => __awaiter(void 0, void 0, void 0, function* () {
                    const { error } = yield GalaxyApi().POST("/api/groups/{group_id}/undelete", {
                        params: {
                            path: { group_id: String(data.id) },
                        },
                    });
                    if (error) {
                        return {
                            status: "danger",
                            message: `Failed to restore '${data.name}': ${errorMessageAsString(error)}`,
                        };
                    }
                    return {
                        status: "success",
                        message: `'${data.name}' has been restored.`,
                    };
                }),
            },
        ],
    },
    {
        key: "roles",
        title: "Roles",
        type: "text",
    },
    {
        key: "users",
        title: "Users",
        type: "text",
    },
    {
        key: "update_time",
        title: "Updated",
        type: "date",
    },
];
const validFilters = {
    name: { placeholder: "name", type: String, handler: contains("name"), menuItem: true },
    deleted: {
        placeholder: "Deleted",
        type: Boolean,
        boolType: "is",
        handler: equals("deleted", "deleted", toBool),
        menuItem: true,
    },
};
/**
 * Grid configuration
 */
const gridConfig = {
    id: "groups-grid",
    actions: actions,
    fields: fields,
    filtering: new Filtering(validFilters, undefined, false, false),
    getData: getData,
    plural: "Groups",
    sortBy: "name",
    sortDesc: true,
    sortKeys: ["name", "update_time"],
    title: "Groups",
};
export default gridConfig;
